<!--
 * @Description: 海康监控视频组件
-->
<template>
  <el-row :gutter="20" class="h-full">
    <div class="pt-10px flex items-center justify-between mt-[-15px] mb-10px ml-10px">
      <TableButtonGroup v-model="activeTab" :list="tabList" />
    </div>
    <el-col :span="showControlling ? 16 : 24" class="h-[calc(100%-40px)] position-relative">
      <div :id="codeData.id" class="w-full h-full" @dblclick="wholeFullScreen"></div>
    </el-col>
    <el-col :span="8" v-if="showControlling && activeTab === '实时视频'">
      <CategoryTitle title="云台控制"></CategoryTitle>
      <div class="mt-20px mb-20px">
        <span class="mr-20px">云台速度</span>
        <el-select
          class="border-0"
          popper-class="document_select-popper"
          v-model="speed"
          size="mini"
          placeholder="请选择云台速度"
        >
          <el-option
            v-for="item in speedOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="mb-40px">
        <div>云台方向</div>
        <div
          class="
            relative
            w-120px
            h-120px
            rounded-1/2
            border-2 border-[#7fe7f0] border-opacity-30
            ml-80px
          "
        >
          <img
            class="controllar-image controllar-image_up"
            src="../images/video-monitor/arrows.png"
            @mousedown="controlCamera('up', 0)"
            @mouseup="controlCamera('up', 1)"
          />
          <img
            class="controllar-image controllar-image_left"
            src="../images/video-monitor/arrows.png"
            @mousedown="controlCamera('left', 0)"
            @mouseup="controlCamera('left', 1)"
          />
          <img
            class="controllar-image controllar-image_right"
            src="../images/video-monitor/arrows.png"
            @mousedown="controlCamera('right', 0)"
            @mouseup="controlCamera('right', 1)"
          />
          <img
            class="controllar-image controllar-image_down"
            src="../images/video-monitor/arrows.png"
            @mousedown="controlCamera('down', 0)"
            @mouseup="controlCamera('down', 1)"
          />
        </div>
      </div>
      <div class="mb-20px">
        <span class="mr-20px">云台镜头</span>
        <img
          class="inline-block mr-8px cursor-pointer"
          src="../images/video-monitor/larger.png"
          @mousedown="controlCamera('zoom_in', 0)"
          @mouseup="controlCamera('zoom_in', 1)"
        />
        <img
          class="inline-block cursor-pointer"
          src="../images/video-monitor/narrow.png"
          @mousedown="controlCamera('zoom_out', 0)"
          @mouseup="controlCamera('zoom_out', 1)"
        />
      </div>
    </el-col>
    <el-col
      :span="8"
      v-if="showControlling && activeTab === '历史回放'"
    >
      <CategoryTitle title="历史回放"></CategoryTitle>
      <div class="mt-20px mb-10px">
        <el-date-picker
          class="w-300px"
          v-model="playbackTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="请选择时间"
          @change="timeChange"
        ></el-date-picker>
        <el-tooltip
          placement="top"
          effect="dark"
          content="请选择回放开始时间，播放当前时间后半小时内视频"
        >
          <img
            class="inline-block cursor-pointer ml-15px"
            src="../../../../../assets/images/videoPlayer/vector.png"
          />
        </el-tooltip>
      </div>
      <div class="mb-20px">
        <el-button
          type="primary"
          class="border-0 !text-white h-36px mt-10px button-bg"
          @click="playbackStart"
          :disabled="isBackPlay"
        >
          开始回放
        </el-button>
        <el-button
          type="primary"
          class="border-0 !text-white h-36px mt-10px button-bg"
          @click="stopPlay"
          :disabled="!isBackPlay"
        >
          停止回放
        </el-button>
        <el-button
          type="primary"
          class="border-0 !text-white h-36px mt-10px button-bg"
          @click="capturePicture"
          v-loading="isCapturePicture"
        >
          截图
        </el-button>
      </div>
      <div class="mb-20px">
        <el-button
          v-if="isPausePlay"
          type="primary"
          class="border-0 !h-40px operation-bg"
          :disabled="!isBackPlay"
          title="播放"
          @click="playbackResume"
        >
          <img class="inline-block" src="../../../../../assets/images/videoPlayer/start.png" />
        </el-button>
        <el-button
          v-if="!isPausePlay"
          type="primary"
          class="border-0 !h-40px operation-bg"
          :disabled="!isBackPlay"
          title="暂停"
          @click="playbackPause"
        >
          <img class="inline-block" src="../../../../../assets/images/videoPlayer/paused.png" />
        </el-button>
        <el-button
          type="primary"
          class="border-0 !h-40px operation-bg"
          :disabled="!isPausePlay"
          title="慢放"
          @click="playbackSlow"
        >
          <img
            class="inline-block"
            src="../../../../../assets/images/videoPlayer/fastForward.png"
          />
        </el-button>
        <el-button
          type="primary"
          class="border-0 !h-40px mr-8px operation-bg"
          :disabled="!isPausePlay"
          title="快放"
          @click="playbackFast"
        >
          <img
            class="inline-block"
            src="../../../../../assets/images/videoPlayer/slowForward.png"
          />
        </el-button>
        <span
          class="
            operation-bg
            inline-block
            w-54px
            h-40px
            leading-40px
            text-center text-white
            mt-[-10px]
          "
        >
          x{{ playback.rate }}
        </span>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import dayjs from 'dayjs'
import { BaseApi } from '@wiz-api/hik-isecure-center'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'

const baseApi = new BaseApi()
export default {
  props: {
    showControlling: {
      type: Boolean,
      default: false,
    },
    codeData: {
      type: Object,
      defalut: () => {},
    },
    playerConfig: {
      type: Object,
      defalut: () => {},
    },
  },
  components: {
    CategoryTitle,
    TableButtonGroup,
  },
  data() {
    return {
      activeTab: '实时视频',
      tabList: ['实时视频', '历史回放'],
      oPlugin: null, // 播放器实例
      curIndex: 0, // 当前选中窗口下标
      iWind: 0, //
      videoUrl: '', // 视频流
      showVideo: false, // resize前需要判断是否实例化完成播放器
      speedOptions: [1, 20, 40, 60, 80, 100],
      speed: '1',
      playbackTime: '',
      isBackPlay: false, // 是否开始回放
      isPausePlay: false, // 是否播放中
      isCapturePicture: false,
      playback: {
        startTime: '',
        endTime: '',
        rate: 1,
      },
    }
  },
  watch: {
    'codeData.code': {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          if ('WebSocket' in window && this.videoUrl) {
            // 关闭上一个websocket连接
            const ws = new WebSocket(this.videoUrl)
            ws.close()
          }
          if (this.oPlugin) {
            this.stopPlay()
          }
          this.$nextTick(() => {
            this.initCamera()
          })
        }
      },
    },
    activeTab(val) {
      if (val) {
        if (val === '历史回放') {
          // 设置默认时间
          this.playbackTime = dayjs().subtract(30, 'minute').format('YYYY-MM-DD HH:mm:ss')
          this.timeChange(this.playbackTime)

          if ('WebSocket' in window && this.videoUrl) {
            // 关闭上一个websocket连接
            const ws = new WebSocket(this.videoUrl)
            ws.close()
          }
        } else {
          // 实时播放
          this.isBackPlay = false
          this.stopPlay()
          this.initCamera()
        }
      }
    },
  },
  computed: {
    systemParams() {
      return this.$store.getters.systemParams || []
    },
    H5playerProtocol() {
      const systemParams = this.$store.getters.systemParams || []
      const obj = _.find(systemParams, { parameterCode: 'H5playerProtocol' })
      return obj ? obj.parameterValue : ''
    },
  },
  created() {},
  mounted() {
    // this.initCamera()
  },
  methods: {
    // 时间段选择(转为IOS8601时间格式)
    timeChange(val) {
      const customerEndTime = dayjs(val).add(30, 'minute').format('YYYY-MM-DD HH:mm:ss')
      const startTime = dayjs(val).add(8, 'hour').format('YYYY-MM-DD HH:mm:ss')
      const endTime = dayjs(customerEndTime).add(8, 'hour').format('YYYY-MM-DD HH:mm:ss')
      this.playback.startTime = new Date(startTime).toISOString().replace('Z', '+08:00')
      this.playback.endTime = new Date(endTime).toISOString().replace('Z', '+08:00')
    },
    // 播放器简单配置
    initCamera() {
      this.oPlugin = new JSPlugin({
        szId: this.codeData.id, // 容器id 需要英文字母开头
        szBasePath: '/lib/video/HKh5Player/', // 资源文件
        iMaxSplit: 1, // 分屏播放，当前为1
        oStyle: {
          // 设置播放器样式
          border: '#343434',
          borderSelect: '#000',
          background: '#000',
        },
        openDebug: true,
      })
      this.initPlugin()
    },
    // 事件初始化
    initPlugin() {
      this.oPlugin.JS_SetWindowControlCallback({
        windowEventSelect(iWndIndex) {
          // 插件选中窗口回调
          this.iWind = iWndIndex
        },
        pluginErrorHandler(iWndIndex, iErrorCode, oError) {
          // 插件错误回调
          console.error(`插件错误回调   window-${iWndIndex}, errorCode: ${iErrorCode}`, oError)
        },
        windowEventOver(iWndIndex) {
          // 鼠标移过回调
          console.log('鼠标移过回调')
        },
        windowEventOut(iWndIndex) {
          // 鼠标移出回调
          console.log('鼠标移出回调')
        },
        windowEventUp(iWndIndex) {
          // 鼠标mouseup事件回调
          console.log('鼠标mouseup事件回调')
        },
        windowFullCcreenChange(bFull) {
          // 全屏切换回调
          console.log('全屏切换回调')
        },
        firstFrameDisplay(iWndIndex, iWidth, iHeight) {
          // 首帧显示回调
          console.log(iWndIndex, iWidth, iHeight)
        },
        performanceLack() {
          // 性能不足回调
          console.log('性能不足回调')
        },
      })
      this.oPlugin
        .JS_SetOptions({
          // bSupportSound: false  //是否支持音频，默认支持
          // bSupporDoubleClickFull: false  //是否双击窗口全屏，默认支持
          // bOnlySupportMSE: true  //只支持MSE
          // bOnlySupportJSDecoder: true  //只支持JSDecoder
        })
        .then(async () => {
          // 播放器实例化完成
          this.showVideo = true
          this.getWS()
        })
    },
    // 获取视频流
    async getWS() {
      const params = {
        cameraIndexCode: this.codeData.code,
        streamType: this.playerConfig.streamType,
        protocol: this.playerConfig.protocol,
        transmode: this.playerConfig.transmode,
        expand: 'transcode=0',
        streamform: 'ps',
      }
      const params2 = {
        url: '/artemis/api/video/v2/cameras/previewURLs',
        input: JSON.stringify(params),
      }
      const [err, res] = await baseApi.postHIK_0(params2)
      console.log(res, '获取实时视频流的接口返回')
      if (!err && res) {
        this.videoUrl = JSON.parse(res).data.url
        this.realplay()
      }
    },
    // 播放视频
    realplay() {
      console.log(this.videoUrl, 'videoUrl-videoUrl')
      this.oPlugin
        .JS_Play(
          this.videoUrl,
          {
            playURL: this.videoUrl,
            mode: 1, // 0：普通模式   1：高级模式
          },
          this.curIndex
        )
        .then(() => {
          console.log('realplay success')
        })
        .catch(() => {
          console.log('realplay failed')
        })
    },
    // 设置窗口大小
    resizeVideo() {
      if (this.showVideo) {
        this.oPlugin
          .JS_Resize()
          .then(() => {
            console.log('resizeplay success')
          })
          .catch(() => {
            console.log('resizeplay failed')
          })
      }
    },
    fullScreen() {
      this.oPlugin
        .JS_FullScreenSingle(this.curIndex)
        .then(() => {
          console.log('JS_FullScreenDisplay success')
        })
        .catch((e) => {
          console.log(e, 'JS_FullScreenDisplay faild')
        })
    },
    // 全屏
    wholeFullScreen() {
      this.oPlugin.JS_FullScreenDisplay(true).then(
        () => {},
        (e) => {
          console.log(e)
        }
      )
    },
    // 摄像头方向控制
    async controlCamera(command, action) {
      const params = {
        cameraIndexCode: this.codeData.code,
        action,
        command,
        speed: this.speed,
      }
      const params2 = {
        url: '/artemis/api/video/v1/ptzs/controlling',
        input: JSON.stringify(params),
      }
      const [err, res] = await baseApi.postHIK_0(params2)
      if (!err) {
        console.log('摄像头操作成功！')
        const code = JSON.parse(res).code
        if (code !== '0') {
          this.$message.error(`海康设备异常状态码：${code}`)
        }
      }
    },
    // 开始回放
    async playbackStart() {
      if (!this.playbackTime) {
        this.$message.warning('请先选择回放时间！')
        return
      }
      if ('WebSocket' in window && this.videoUrl) {
        // 关闭上一个websocket连接
        const ws = new WebSocket(this.videoUrl)
        ws.close()
      }
      if (this.oPlugin) {
        this.stopPlay()
      }
      const playURL = await this.getPlaybackUrl()
      const mode = 1
      const startTime = this.playback.startTime
      const endTime = this.playback.endTime

      this.oPlugin.JS_Play(playURL, { playURL, mode }, 0, startTime, endTime).then(
        () => {
          console.log('playbackStart success')
          this.playback.rate = 1
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 获取视频回放流
    async getPlaybackUrl() {
      let playUrl = ''
      const params = {
        cameraIndexCode: this.codeData.code,
        recordLocation: this.playerConfig.recordLocation,
        protocol: this.playerConfig.protocol,
        transmode: this.playerConfig.transmode,
        beginTime: this.playback.startTime,
        endTime: this.playback.endTime,
        expand: 'transcode=0',
        streamform: 'ps',
        lockType: 0,
      }
      const params2 = {
        url: '/artemis/api/video/v2/cameras/playbackURLs',
        input: JSON.stringify(params),
      }
      const [err, res] = await baseApi.postHIK_0(params2)
      console.log(res, '获取回放视频流的接口返回')
      if (!err && res) {
        playUrl = JSON.parse(res).data.url
        this.isBackPlay = true
      }
      return playUrl
    },
    // 停止回放
    stopPlay() {
      this.isBackPlay = false
      this.isPausePlay = false
      this.oPlugin.JS_StopRealPlayAll().then(
        () => {
          this.playback.rate = 1
          console.log('JS_StopRealPlayAll success')
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 截图
    capturePicture() {
      this.isCapturePicture = true
      this.oPlugin
        .JS_CapturePicture(0, `监控截图${dayjs().format('YYYYMMDDHHmmss')}`, 'JPEG')
        .then((res) => {
          this.isCapturePicture = false
          console.log(res, '截图')
        })
        .catch(() => {
          this.isCapturePicture = false
        })
    },
    // 播放
    playbackResume() {
      this.isPausePlay = !this.isPausePlay
      this.oPlugin.JS_Resume(0).then(
        () => {
          console.log('JS_Resume success')
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 暂停
    playbackPause() {
      this.isPausePlay = !this.isPausePlay
      this.oPlugin.JS_Pause(0).then(
        () => {
          console.log('JS_Pause success')
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 慢放
    playbackSlow() {
      this.oPlugin.JS_Slow(0).then(
        (rate) => {
          this.playback.rate = rate
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 快放
    playbackFast() {
      this.oPlugin.JS_Fast(0).then(
        (rate) => {
          this.playback.rate = rate
        },
        (e) => {
          console.error(e)
        }
      )
    },
  },
  beforeDestroy() {
    this.stopPlay()
  },
}
</script>

<style lang="scss" scoped>
.controllar-image {
  width: 22px;
  cursor: pointer;
  position: absolute;
  &_up {
    transform: rotate(90deg);
    top: 10px;
    left: 50px;
  }
  &_right {
    transform: rotate(180deg);
    right: 10px;
    top: 50px;
  }
  &_down {
    transform: rotate(-90deg);
    bottom: 10px;
    left: 50px;
  }
  &_left {
    left: 10px;
    top: 50px;
  }
}
.button-bg {
  background: url('../../../../../assets/images/button_blue.png') !important;
  background-size: 100% 100% !important;
  &:hover {
    background: url('../../../../../assets/images/button_yellow.png') !important;
    background-size: 100% 100% !important;
  }
}
.operation-bg {
  background: url('../../../../../assets/images/videoPlayer/usOperationBg.png') !important;
  background-size: 100% 100% !important;
  &:hover {
    background: url('../../../../../assets/images/videoPlayer/sOperationBg.png') !important;
    background-size: 100% 100% !important;
  }
}
::v-deep {
  .el-input__inner {
    border: 1px solid #587b7e !important;
  }
}
</style>
